(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      /* Measure BEFORE fixed positioning takes effect, then set --header-height */
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      /* Transparent header detection */
      this.transparentEnabled = this.hasAttribute('data-transparent-header-enabled');
      this.isTransparent = false;
      if (this.transparentEnabled) {
        const mainContent = document.getElementById('MainContent');
        if (mainContent) {
          const firstSection = mainContent.querySelector('[data-section-transparent-header]');
          if (firstSection) {
            this.isTransparent = true;
            this.classList.add('header-wrapper--transparent');
          }
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setAttribute('data-transparent-ready', '');
          });
        });
      }

      /* NO scroll listener — sticky-section-titles.js is the sole scroll controller */
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
